import { RefreshIcon } from '@/assets/icons/info-icons/refresh';
import { RefreshButton, Results, TopWrapper } from '@/components/table/filterPage/desktop-filter';
import TablePagination from '@/components/table/tablePagination';
import { ISort, SORT_ORDER } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';
import { themeVar } from '@/styles/theme';
import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { LIST_ALLOCATION_OPERATIONS_WORKFLOW_TRANSITION_HISTORY_QUERY } from '../queries';
import { AllocationOperationsWorkflowTransitionHistoryDto, ListAllocationOperationsWorkflowTransitionHistoryResponseDto } from '../types';
import Table from './table/table';

interface ActivityLogTabProps {
  sort: ISort;
  paginationValues: { limit: number; offset: number };
  onChangeSort: (value: ISort) => void;
  onChangePaginationData: (limit: number, offset: number) => void;
}

export const ActivityLogTab = ({ sort, paginationValues, onChangeSort, onChangePaginationData }: ActivityLogTabProps) => {
  const params = useParams();
  const { isMobile, isTablet } = useResponsive();

  const [activityLogTableData, setActivityLogTableData] = useState<AllocationOperationsWorkflowTransitionHistoryDto[]>([]);
  const [total, setTotal] = useState(0);

  const { loading: listAllocationOperationsWorkflowTransitionHistoryLoading, refetch: listAllocationOperationsWorkflowTransitionHistoryRefetch } =
    useQuery<{
      listAllocationOperationsWorkflowTransitionHistory: ListAllocationOperationsWorkflowTransitionHistoryResponseDto;
    }>(LIST_ALLOCATION_OPERATIONS_WORKFLOW_TRANSITION_HISTORY_QUERY, {
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      variables: {
        data: {
          filterByAllocationId: params?.allocationId,
          sort: sort.key || 'createdAt',
          order: sort.asc ? SORT_ORDER.ASC : SORT_ORDER.DESC,
          pageSize: Number(paginationValues.limit),
          page: Math.floor(Number(paginationValues.offset) / Number(paginationValues.limit)) + 1
        }
      },
      onCompleted: (data) => {
        setTotal(data?.listAllocationOperationsWorkflowTransitionHistory?.total ?? 0);
        setActivityLogTableData(data?.listAllocationOperationsWorkflowTransitionHistory?.data ?? []);
      },
      onError: (error) => {
        console.error(error);
      }
    });

  return (
    <>
      <CustomRefetch isMobile={isMobile} isTablet={isTablet}>
        <Results>{total ?? 0} Results</Results>
        <RefreshButton onClick={() => listAllocationOperationsWorkflowTransitionHistoryRefetch()}>
          <RefreshIcon fill={themeVar('action.primary')} />
        </RefreshButton>
      </CustomRefetch>
      <Table
        activityLogTableData={activityLogTableData}
        loading={listAllocationOperationsWorkflowTransitionHistoryLoading}
        sort={sort}
        setSort={onChangeSort}
        refetch={() => {}}
      />
      <PaginationWrap>
        <TablePagination savePagination={onChangePaginationData} paginationValues={{ ...paginationValues, total }} refetch={() => null as any} />
      </PaginationWrap>
    </>
  );
};

const CustomRefetch = styled(TopWrapper)<{ isMobile: boolean; isTablet: boolean }>`
  position: sticky;
  top: ${({ isMobile, isTablet }) => (isMobile || isTablet ? '50px' : '0')};
  padding: 50px 0 10px 0;
  background-color: ${themeVar('layer.base')};
  z-index: 10;
`;

const PaginationWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;
